var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.4999 16.293H16.5M3.5 16.293L7.13832 15.5599C7.33147 15.521 7.50882 15.4259 7.6481 15.2865L15.7928 7.13734C16.1833 6.74663 16.1831 6.11331 15.7922 5.72292L14.0669 3.99952C13.6762 3.6093 13.0432 3.60957 12.6529 4.00012L4.5073 12.1502C4.36829 12.2892 4.27337 12.4662 4.23442 12.659L3.5 16.293Z",
    stroke: "#2D2B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit03);
export default __webpack_public_path__ + "static/media/edit-03.90d05c6e01de6a4deaa6f01f9c74d847.svg";
export { ForwardRef as ReactComponent };